import axios from "axios";
import { toast } from "react-toastify";
import { server } from "../../server";

export const getAllTelecallers =
  (pageNo, pageSize, searchParams) => async (dispatch) => {
    dispatch({ type: "GET_ALL_TELECALLERS_REQUEST" });
    try {
      const { data } = await axios.get(`${server}/contact/getAllContacts`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo,
          pageSize,
          searchParams,
        },
      });

      dispatch({
        type: "GET_ALL_TELECALLERS_SUCCESS",
        payload: { contactsList: data?.data, count: data?.count },
      });
    } catch (e) {
      dispatch({ type: "GET_ALL_TELECALLERS_FAIL" });
      toast.error(e?.response?.data?.message || e?.message);
    }
  };
